import { render, staticRenderFns } from "./WFRight.vue?vue&type=template&id=8b697d38&scoped=true"
import script from "./WFRight.vue?vue&type=script&lang=js"
export * from "./WFRight.vue?vue&type=script&lang=js"
import style0 from "./WFRight.vue?vue&type=style&index=0&id=8b697d38&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b697d38",
  null
  
)

export default component.exports